import { Link, useNavigate } from 'react-router-dom'
import { Col, Form, FormGroup, Input, Label, Row } from 'reactstrap'
import { URL_API } from '../../../utils/helper/helpers'
import { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Btn } from '../../../AbstractElements';
import { useAppDispatch, useAppSelector } from '../../../ReduxToolkit/Hooks';
import { clearCart } from '../../../ReduxToolkit/Reducers/CartSlice';

const CheckoutForm = () => {
  const Token = JSON.parse(localStorage.getItem("login")!);
  const dispatch = useAppDispatch();
  const { cart } = useAppSelector((state) => state.cartData);
  const clearPanier = () => dispatch(clearCart());
  const navigate = useNavigate();
  const [data, setData] = useState({
    fullname: '',
    phone: '',
    email: '',
    adresse: '',
  });
  const [erreur, setErreur] = useState({
    fullname: '',
    phone: '',
    email: '',
    adresse: '',
  });
  const clearDataForm = () => {
    setData({
      fullname: '',
      phone: '',
      email: '',
      adresse: '',
    });
    setErreur({
      fullname: '',
      phone: '',
      email: '',
      adresse: '',
    });
  }
  const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };
  const handleSubmitData = (e: React.FormEvent) => {
    e.preventDefault();

    axios.post(`${URL_API}/vente/create`, { ...data, cart }, {
      headers: {
        Authorization: `Bearer ${Token}`
      }
    }).then(response => {

      if (response.status === 200) {
        toast.success(response.data.message);
        clearDataForm();
        clearPanier();
        navigate(`/vente-facture/${response.data.vente}`)

      }


    }).catch(error => {
      if (error.status == 405) {
        toast.info("Oups !! Erreur de validation des données");
        setErreur(error.response.data.message);
      }
    })
  }
  return (
    <Form onSubmit={handleSubmitData}>
      <Row>
        <Col sm="12">
          <FormGroup>
            <Label for="inputEmail4">Nom & Prénoms</Label>
            <Input id="inputEmail4"
              type="text"
              placeholder="Entrer le nom complet"
              name='fullname'
              value={data.fullname}
              onChange={changeHandler} />
            {erreur.fullname && (<span className="text-danger">{erreur.fullname}</span>)}
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm="6">
          <FormGroup>
            <Label for="inputEmail5">Téléphone</Label>
            <Input id="inputEmail5"
              type="number"
              placeholder="Entrer le telephone du client"
              name='phone'
              value={data.phone}
              onChange={changeHandler} />
            {erreur.phone && (<span className="text-danger">{erreur.phone}</span>)}
          </FormGroup>
        </Col>
        <Col sm="6">
          <FormGroup>
            <Label for="inputPassword7">E-mail</Label>
            <Input id="inputPassword7"
              type="email"
              placeholder="Entrer l'email du client"
              name='email'
              value={data.email}
              onChange={changeHandler} />
            {erreur.email && (<span className="text-danger">{erreur.email}</span>)}
          </FormGroup>
        </Col>
      </Row>
      <FormGroup>
        <Label for="inputAddress5">Adesse</Label>
        <Input id="inputAddress5"
          type="text"
          placeholder="Entrer l'adresse du client"
          name='adresse'
          value={data.adresse}
          onChange={changeHandler} />
        {erreur.adresse && (<span className="text-danger">{erreur.adresse}</span>)}
      </FormGroup>
      <div className="order-place">
        <Btn type={'submit'} className='btn btn-primary' > Valider la commande </Btn>
      </div>
    </Form>
  )
}

export default CheckoutForm